export const useStyles = (theme) => ({
  root: {},
  paper: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  profileContent: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  dividerStyle: {
    color: "#181818",
  },
  bottomRoot: {
    color: "#111",
  },
  bottom: {
    color: "#181818",
    fontWeight: "bold",
  },
  navLabel: {
    fontSize: 16,
    "&:hover": {
      fontSize: 18,
    },
  },
  navRoot: {
    width: "100%",
    padding: 10,
    display: "flex",
    flexDirection: "column",
  },
  navContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
});
